// Jquery functions
(function($) {
	// LazyLoading
	//img
	var myLazyLoad = new LazyLoad({
		elements_selector: "[data-src], [data-srcset], [data-bg], [data-sizes]",
		load_delay: 100,
		callback_set: function(el) {
			if (typeof $(el).attr("data-src") !== typeof undefined && $(el).attr("data-src") !== false) {
				$(el).removeAttr("data-src");
			}
			if (typeof $(el).attr("data-srcset") !== typeof undefined && $(el).attr("data-srcset") !== false) {
				$(el).removeAttr("data-srcset");
			}
			if (typeof $(el).attr("data-bg") !== typeof undefined && $(el).attr("data-bg") !== false) {
				$(el).removeAttr("data-bg");
			}
			if (typeof $(el).attr("data-sizes") !== typeof undefined && $(el).attr("data-sizes") !== false) {
				$(el).removeAttr("data-sizes");
			}
			objectFitImages(el);
		}
	});
	// iframe and table (wysiwyg editor)
	$(".entry-content iframe").each(function() {
		if (
			$(this).attr("src").indexOf("youtube") != -1 ||
			$(this).attr("src").indexOf("vimeo") != -1 ||
			$(this).attr("src").indexOf("maps") != -1
		) {
			$(this)
				.addClass("embed-responsive-item")
				.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
			$(this).removeAttr("width");
			$(this).removeAttr("height");
		}
	});
	$(".entry-content table").each(function() {
		$(this)
			.addClass("table")
			.wrap('<div class="table-responsive"></div>');
	});
	//header
	$(document).scroll(function() {
	  if ($(document).scrollTop() >= 74) {
	    $('.header').addClass('is-scrolled');
	  } else {
	    $('.header').removeClass('is-scrolled');
	  }
	});
	//nav
	$('.nav-opener').click(function(){
		var winH = $(window).height();
		$(this).toggleClass('is-active');
		$('.nav-container').toggleClass('is-active');
		$('#riacontrol').toggleClass("nav-open");
		if ($(this).hasClass("is-active")) {
			$.scrollLock(true);
			$('.nav-container').css("height", winH);
		} else {
			$.scrollLock(false);
			$('.nav-container').removeAttr("style");
		}
	});
	$(window).resize(function(){
		if (window.matchMedia("(max-width: 47.938em)").matches) {
			var winH = $(window).height();
			$('.m-nav-container').css("height", winH);
		} else {
			$('.m-nav-container').removeAttr("style");
		}
	});
	$('.menu-prevent-default > a').click(function(event){
		event.preventDefault();
		if (window.matchMedia("(max-width: 61.937em)").matches) {
			$(this).parent().find('> ul').slideToggle();
		}
	});
	if($('.news-section').length) {
		$('.news-slider').slick({
			prevArrow: $('.news-box .slick-prev'),
			nextArrow: $('.news-box .slick-next'),
			infinite: true,
		  slidesToShow: 3,
		  slidesToScroll: 1,
			dots: true,
			responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 2
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 1
		      }
		    }
  		]
		});
	}
	//toggle content
	if($('.detail-toggle').length) {
		$('.detail-toggle .h4').click(function(){
			$(this).toggleClass('is-active');
			$(this).parent().find('.detail-hidden').slideToggle();
		});
	}
	if( $(".gallery").length > 0 ) {
		$("body").append('<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\
			<div class="pswp__bg"></div>\
			<div class="pswp__scroll-wrap">\
					<div class="pswp__container">\
							<div class="pswp__item"></div>\
							<div class="pswp__item"></div>\
							<div class="pswp__item"></div>\
					</div>\
					<div class="pswp__ui pswp__ui--hidden">\
							<div class="pswp__top-bar">\
									<div class="pswp__counter"></div>\
									<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\
									<div class="pswp__preloader">\
											<div class="pswp__preloader__icn">\
													<div class="pswp__preloader__cut">\
															<div class="pswp__preloader__donut"></div>\
													</div>\
											</div>\
									</div>\
							</div>\
							<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\
									<div class="pswp__share-tooltip"></div>\
							</div>\
							<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"> </button>\
							<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"> </button>\
							<div class="pswp__caption">\
									<div class="pswp__caption__center"></div>\
							</div>\
					</div>\
			</div>\
		</div>');
	}
	$('.gallery').photoswipe({
		loop: true,
		bgOpacity: 1
	});
})( jQuery );
